<template>
    
<div class="articles-detail">
    <h1>Welcome to CDS Flight Deck Help Articles! Choose a subject on the left to begin or search for a topic above.</h1>
</div>

</template>

<script>
export default {

}
</script>

<style>

</style>
